module.exports = __webpack_public_path__ + "conheca/static/media/marcador2.f8b5ade7.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/marcador2.png
// module id = 330
// module chunks = 37